import { rankingItems } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-primary-400 text-background-50',
  3: 'bg-primary-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网黑料视频热度排行，看看大家都在关注什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.rank}
                href="#media"
                className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-base font-bold flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 font-medium truncate">
                    {item.title}
                  </p>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                    {item.heat}
                  </span>
                  {item.tag && (
                    <span
                      className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                        item.tag === 'HOT'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-accent-100 text-accent-800'
                      }`}
                    >
                      {item.tag}
                    </span>
                  )}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}